export default function SowFolderIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="3.75" fill="#FFDCF3" />
      <path
        d="M6 9.46634C6 8.7196 6 8.34623 6.14533 8.06102C6.27315 7.81013 6.47713 7.60616 6.72801 7.47833C7.01323 7.33301 7.3866 7.33301 8.13333 7.33301H10.4497C10.7758 7.33301 10.9389 7.33301 11.0923 7.36985C11.2283 7.40251 11.3584 7.45638 11.4777 7.52949C11.6123 7.61194 11.7276 7.72724 11.9582 7.95785L12.0418 8.0415C12.2724 8.27211 12.3877 8.38741 12.5223 8.46986C12.6416 8.54297 12.7717 8.59684 12.9077 8.6295C13.0611 8.66634 13.2242 8.66634 13.5503 8.66634H15.8667C16.6134 8.66634 16.9868 8.66634 17.272 8.81167C17.5229 8.93949 17.7269 9.14347 17.8547 9.39435C18 9.67957 18 10.0529 18 10.7997V14.533C18 15.2797 18 15.6531 17.8547 15.9383C17.7269 16.1892 17.5229 16.3932 17.272 16.521C16.9868 16.6663 16.6134 16.6663 15.8667 16.6663H8.13333C7.38659 16.6663 7.01323 16.6663 6.72801 16.521C6.47713 16.3932 6.27315 16.1892 6.14533 15.9383C6 15.6531 6 15.2797 6 14.533V9.46634Z"
        stroke="#F31DED"
        stroke-width="1.45455"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
